import type { AtAGlanceBucketSize } from "@insights/contracts";

export function normalizeBucketSize(value: string | null): AtAGlanceBucketSize {
  return value === "month" ? value : "week";
}

export function percentageChange(current: number, previous: number) {
  if (previous === 0) {
    return current === 0 ? 0 : 100;
  }

  return ((current - previous) / previous) * 100;
}

export function formatChange(value: number) {
  const rounded = Math.round(value);
  if (rounded > 0) {
    return `+${rounded}%`;
  }

  return `${rounded}%`;
}

export function formatDuration(milliseconds: number) {
  const totalMinutes = Math.round(milliseconds / 60_000);
  if (totalMinutes < 60) {
    return `${totalMinutes}m`;
  }

  const totalHours = Math.round(milliseconds / 3_600_000);
  if (totalHours < 48) {
    return `${totalHours}h`;
  }

  return `${Math.round(milliseconds / 86_400_000)}d`;
}

export function savingsPercentage(saved: number, actual: number) {
  const potential = saved + actual;
  return potential === 0 ? 0 : (saved / potential) * 100;
}

export function bucketLabel(from: string, size: AtAGlanceBucketSize) {
  const date = new Date(from);
  if (size === "month") {
    return new Intl.DateTimeFormat("en", {
      month: "short",
      timeZone: "UTC",
    }).format(date);
  }

  const day = date.getUTCDay() || 7;
  const thursday = new Date(date);
  thursday.setUTCDate(thursday.getUTCDate() + 4 - day);
  const firstThursday = new Date(Date.UTC(thursday.getUTCFullYear(), 0, 4));
  const firstThursdayDay = firstThursday.getUTCDay() || 7;
  firstThursday.setUTCDate(
    firstThursday.getUTCDate() + 4 - firstThursdayDay,
  );
  const week = 1 + Math.round(
    (thursday.getTime() - firstThursday.getTime()) / (7 * 86_400_000),
  );
  return `W${String(week).padStart(2, "0")}`;
}
